import { render, staticRenderFns } from "./academic_word_feedback.vue?vue&type=template&id=f4e6c1aa&scoped=true&"
import script from "./academic_word_feedback.vue?vue&type=script&lang=js&"
export * from "./academic_word_feedback.vue?vue&type=script&lang=js&"
import style0 from "./academic_word_feedback.vue?vue&type=style&index=0&id=f4e6c1aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4e6c1aa",
  null
  
)

export default component.exports